<template>
  <v-card class="navigation-panel" elevation="0">
    <v-layout>
      <v-navigation-drawer v-model="navigation.shown" :elevation="0">

        <v-list-item @click="goTo('/home/dashboard')" class="text-center" >
          <div class="text-center" v-if="getCurrentCompany != null">
            <img :src="getCurrentCompany.logo_thumb ? getFileServerUrl + getCurrentCompany.logo_thumb : '@/assets/image/logo.png'" :alt="getCurrentCompany.name" class="logo2" style="width: 220px; max-width: 100%; height: 70px; object-fit: cover;" />
          </div>
        </v-list-item>
        
        <v-list-item @click="goTo('/home/dashboard')" class="text-center module-heading" >{{ module_name }}</v-list-item>
        <v-list class="sidebar-menu" density="compact" nav color="primary">
          <template v-for="item in getNavbarItemsFeatures">
          <v-list-group :value="item.name" v-if="item.menu.length > 0" expand-icon="mdi-chevron-down" collapse-icon="mdi-chevron-up">
            <template v-slot:activator="{ props }">
              <v-list-item
                v-bind="props"
                :prepend-icon="item.icon"
                :title="item.name"
              ></v-list-item>
            </template>
              <template v-for="(child, i) in item.menu" >
                <router-link :to="child.link" class="text-decoration-none navigation-link">
                    <v-list-item                     
                      :key="i"
                      :value="child.name"
                      :title="child.name"
                      :prepend-icon="child.icon"
                      :active="activeMenuItem === child.link"
                      @click="unSelectButton(item.name, child.name, child.link)"
                      style="padding-inline-start: 20px !important;"
                      >
                    </v-list-item>
                </router-link>
              </template>
          </v-list-group>
        </template>
        </v-list>
      </v-navigation-drawer>
      
      <v-main style="height: 100vh"></v-main>
    </v-layout>
  </v-card>
</template>
<script>
  export default {
    props: ["navigation"],
    data: () => ({
        toggle: "Dashboard",
        module_name: "",
        prefix: '',
        navigation: {
          shown: false,
        },
        activeMenuItem: null 
    }),
    
    created (){

    },
    watch: {
      '$route': {
          immediate: true,
          handler(to) {
              this.getNavbarItemsFeatures.forEach(item => {
                item.menu?.forEach(child => {
                  if (child.link === to.path) {
                      this.activeMenuItem = child.link;
                      this.toggle = item.name;
                  }
                });
              });
          }
      },
  },
    computed: {
      getNavbarItems(){
        return this.$store.getters.getNavbarItems
      },
      getCurrentCompany() {
        return this.$store.getters.getCurrentCompany;
      },
      getNavbarItemsFeatures() {
        const menu = JSON.parse(localStorage.getItem("menu")) || [];
        const prefix = this.prefix;
        const data = menu.filter(el => el.prefix == prefix);
        this.module_name = data[0]?.name || "";
        const subModules = data.flatMap(item => item.sub_module || []);
        this.loading = true;
        return subModules;
      },
      getFileServerUrl() {
          return this.$store.getters.getFileServerUrl;
      },
  },
    methods:{
      goTo(val) {
        this.$router.push({ path: val }).catch(err => {});
      },
      unSelectButton(parentName, childName, childLink){
        this.toggle = parentName;
        this.activeMenuItem = childLink;
      }
    },
    mounted(){
        const first_segment = this.$route.path.split('/')[1] || '';
        if (first_segment == 'module') {
            this.prefix = this.$route.path.split('/')[2] || '';;
        }else {
            this.prefix = first_segment;
        }

    }, 
  }
</script>

<style>
  .navigation-panel, .navigation-panel .v-navigation-drawer { box-shadow: none !important; }
  .navigation-panel .v-navigation-drawer { border: 0; background: #fff; }
  .navigation-panel .module-heading { margin: 12px 10px; background: #e8f3f0; color: #155e57; font-size: 14px; font-weight: 700; border-left: 3px solid #117873; }
  .navigation-panel .v-list { padding: 4px 10px; }
  .navigation-panel .v-list-item-title { font-size: 13px; line-height: 1.5; }
  .navigation-panel .navigation-link { display: block; color: #49645c; }
  .navigation-panel .v-list-item { margin-bottom: 3px !important; }
  .navigation-panel .sidebar-menu .v-list-item { border-bottom: 1px solid #dfe8e4; border-radius: 0; color: #36594f; transition: background-color 160ms ease, color 160ms ease, box-shadow 160ms ease; }
  .navigation-panel .sidebar-menu .v-list-item__prepend > .v-icon { color: #ea580c; opacity: 1; transition: color 160ms ease; }
  .navigation-panel .sidebar-menu .v-list-group__header .v-list-item-title { font-weight: 600; }
  .navigation-panel .sidebar-menu .v-list-group__header .v-list-item__append > .v-icon { font-size: 20px; color: #647d74; opacity: 1; }
  .navigation-panel .sidebar-menu .v-list-item:hover,
  .navigation-panel .sidebar-menu .v-list-item:focus-visible,
  .navigation-panel .sidebar-menu .navigation-link:focus-visible .v-list-item { color: #0d625a; background: #edf7f4; }
  .navigation-panel .sidebar-menu .v-list-item:hover .v-list-item__prepend > .v-icon { color: #c2410c; }
  .navigation-panel .sidebar-menu .v-list-item--active { color: #0b6259; background: #dff1eb; font-weight: 600; box-shadow: inset 3px 0 #117873; }
  .navigation-panel .sidebar-menu .v-list-item--active .v-list-item__prepend > .v-icon { color: #c2410c; }
  .navigation-panel .sidebar-menu .v-list-item--active:hover { background: #d4ebe3; }
  @media (prefers-reduced-motion: reduce) {
    .navigation-panel .sidebar-menu .v-list-item,
    .navigation-panel .sidebar-menu .v-list-item__prepend > .v-icon { transition: none; }
  }
  .navigation-panel .navigation-link:focus-visible { outline: 2px solid #117873; outline-offset: 1px; }
  .v-list-item--density-compact.v-list-item--one-line {
      min-height: 35px !important;
  }

  .v-list-group__items .v-list-item {
      padding-inline-start: unset !important;
      padding-left: 5px !important;
  }

  .start-padding{
      padding-inline-start: 0px !important;
  }

  .v-list .v-list-item--nav:not(:only-child) {
      margin-bottom: 0px !important;
  }
</style>
